import { createValidator, maxLength, required, requiredRichText, richTextMaxLength } from 'util/validation'

import { atestadoSelectModelDefaultRecord } from '../components/model-atestado'
import { AtestadoModeloModel } from './AtestadoModeloModal'

const nomesAtestadoModelosDefault = Object.values(atestadoSelectModelDefaultRecord).map((modelo) =>
  modelo.nome.toUpperCase()
)

export const atestadoModeloModalValidator = createValidator<AtestadoModeloModel>(
  {
    nome: [required, maxLength(40)],
    descricao: [requiredRichText, richTextMaxLength(4000)],
  },
  (values: AtestadoModeloModel, errors) => {
    const nomeNormalizado = values.nome?.trim().toUpperCase()

    if (nomeNormalizado && nomesAtestadoModelosDefault.includes(nomeNormalizado)) {
      errors.nome = 'Já existe um modelo de atestado com este nome.'
    }

    return errors
  }
)
